export enum SituacaoRequisicaoEnum {
  AguardandoAnalise = 1,
  RequisicaoAtendida
}
